module.exports = __webpack_public_path__ + "static/media/note.4b2d4d71.svg";